function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { shouldSeeContactUs } from "services/pricing-service";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import Button from "components/core/button/button-component";
import { XS } from "/components/core/new-button/button-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { HP_SOURCE, CONTACT_US_BUTTON_CLICKED } from "constants/bigbrain-event-types";
import { getPricingContactUsLink } from "services/pricing/pricing-page/contact-us-link-service";
import { withAbTests } from "/contexts/ab-tests-context";
import { PLAN_INFO_SEGMENT_NAME } from "constants/pricing";
import { StyledPricingSignupButton, StyledPricingContactUsButton } from "./pricing-action-button.scss";
import DefaultProps from "./default-props";
class PricingActionButton extends PureComponent {
    render() {
        const { plan, userCount, clusterConfig, abTests, cookies, forcePricing } = this.props;
        const { tier } = plan;
        return shouldSeeContactUs(tier, userCount, {
            clusterConfig,
            abTests,
            cookies,
            forcePricing
        }) ? this.getContactUsButton() : this.getRegularSignupButton();
    }
    constructor(props){
        super(props);
        _define_property(this, "onContactUsClicked", ()=>{
            const { userCount, plan, placement } = this.props;
            BigBrain("track", CONTACT_US_BUTTON_CLICKED, {
                placement,
                source: HP_SOURCE,
                info1: plan.tier,
                info2: userCount
            });
            this.redirectToSalesPage();
        });
        _define_property(this, "redirectToSalesPage", ()=>{
            const { plan, clusterConfig, abTests, forcePricing, cookies } = this.props;
            window.location = getPricingContactUsLink(plan.tier, clusterConfig, abTests, cookies, forcePricing);
        });
        _define_property(this, "getContactUsButton", ()=>{
            const { contactUsButtonText } = this.props;
            return /*#__PURE__*/ _jsx(StyledPricingContactUsButton, {
                children: /*#__PURE__*/ _jsx(Button, {
                    onClickCallback: this.onContactUsClicked,
                    disableAnimation: true,
                    size: XS,
                    color: "outline-dark-blue-inverted-hover",
                    className: "pricing-contact-us-button",
                    children: contactUsButtonText
                })
            });
        });
        _define_property(this, "getRegularSignupButton", ()=>{
            const { plan, signupButtonText, userCount, billingPeriod } = this.props;
            return /*#__PURE__*/ _jsx(StyledPricingSignupButton, {
                children: /*#__PURE__*/ _jsx(SignupFormComponent, {
                    parentSegment: PLAN_INFO_SEGMENT_NAME,
                    buttonSize: XS,
                    buttonColor: "outline-indigo-inverted-hover",
                    ctaText: signupButtonText,
                    buttonSource: plan.tier,
                    useCtaText: true,
                    className: "pricing-signup-button",
                    pricingDetails: {
                        tier: plan === null || plan === void 0 ? void 0 : plan.tier,
                        userCount,
                        billingPeriod
                    },
                    extraData: {
                        pricing_tier: plan === null || plan === void 0 ? void 0 : plan.tier
                    }
                })
            });
        });
    }
}
export default withAbTests(withGenericConfig(PricingActionButton));
PricingActionButton.defaultProps = DefaultProps;
